var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var StarWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 20px;\n\n  svg {\n    width: 100%;\n  }\n"], ["\n  width: 20px;\n\n  svg {\n    width: 100%;\n  }\n"])));
export var RatingWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .rating {\n   & > span {\n       margin-right: 2px;\n   }\n  }\n"], ["\n  .rating {\n   & > span {\n       margin-right: 2px;\n   }\n  }\n"])));
var templateObject_1, templateObject_2;
